import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/core/service/user.service';
import { finalize } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-perfil-edit',
  templateUrl: './perfil-edit.component.html',
  styleUrls: ['./perfil-edit.component.sass']
})
export class PerfilEditComponent implements OnInit {
  @Input() userId: string;
  form: FormGroup;
  hide = true;
  constructor(
    public modal: NgbActiveModal,
    private fb:  FormBuilder,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.userService.getById(this.userId).subscribe(data => {
      console.log(data);
      this.form.patchValue({
        username: data.username,
        password: '',
        email: data.email,
        nombres: data.nombres,
        apellidos: data.apellidos,
        ci: data.ci,
        celular: data.celular,
        club_id: data.club_id,
        roles: data.roles,
      });
    });
  }
  createForm(){
    this.form = this.fb.group({
      username: ['', Validators.required],
      password: [''],
      email: ['', [Validators.required, Validators.email]],
      nombres: [
        '',
        [Validators.required, Validators.pattern('[a-zA-ZñÑáéíóúÁÉÍÓÚ ]*')]
      ],
      apellidos: [
        '',
        [Validators.required, Validators.pattern('[a-zA-ZñÑáéíóúÁÉÍÓÚ ]*')]
      ],
      // fecha_nacimiento: ['',Validators.required],
      ci: ['',Validators.required],
      celular: [
        '',
        [
          Validators.required,
          Validators.maxLength(8),
          Validators.pattern('[0-9]*')
        ]
      ],
      roles:'',
      club_id: ''
    });
  }
  editar(form: any) {
      this.userService
        .update(this.userId, form)
        .pipe(
          finalize(() => {
            this.form.markAsPristine();
          })
        )
        .subscribe(
          data3 => {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Usuario Editado con exito',
              showConfirmButton: false,
              timer: 1500
            });
            // this.toastr.success(data3.succes, 'Éxito');
            this.modal.close(data3);
          },
          (error: any) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.error,
            });
            // this.toastr.error(error.error, 'Error');
          }
        );
  }
}
